import { siteInfo } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h4 className="text-lg font-heading font-bold mb-3">吃瓜官网</h4>
            <p className="text-sm text-white/50 leading-relaxed">
              {siteInfo.slogan}。每日更新海量明星黑料与娱乐圈内幕，300万+瓜友的共同选择。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li>
                <a href="#carousel" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">
                  焦点专题
                </a>
              </li>
              <li>
                <a href="#updates" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">
                  最新快讯
                </a>
              </li>
              <li>
                <a href="#media" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">
                  爆料视频
                </a>
              </li>
              <li>
                <a href="#index" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">
                  热门专题
                </a>
              </li>
              <li>
                <a href="#ranking" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">
                  吃瓜热度榜
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">
                  平台介绍
                </a>
              </li>
              <li>
                <a href="#contact" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">
                  投稿爆料
                </a>
              </li>
              <li>
                <a href="#faq" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">
                  常见问题
                </a>
              </li>
              <li>
                <a href="#features" className="text-sm text-white/50 hover:text-white transition-colors cursor-pointer">
                  平台特色
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">合作伙伴</h4>
            <p className="text-sm text-white/30 leading-relaxed">
              感谢所有合作伙伴的支持与信任。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#hero" className="w-9 h-9 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-wechat-line text-white/70"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-weibo-line text-white/70"></i>
              </a>
              <a href="#hero" className="w-9 h-9 rounded-lg bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-white/70"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-white/30">
            &copy; {new Date().getFullYear()} 吃瓜官网 版权所有
          </p>
          <p className="text-xs text-white/20">
            本平台内容仅供娱乐参考，不构成任何建议或承诺
          </p>
        </div>
      </div>
    </footer>
  );
}